module.exports = __webpack_public_path__ + "static/img/geotap-game-play-store-feature.3f3f2c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laurels/geotap-game-play-store-feature.png
// module id = r6Sm
// module chunks = 0